/**
 * Shared layout shell for static legal pages — Privacy / Terms / Refund.
 */
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "@phosphor-icons/react";

export function LegalShell({ title, overline, lastUpdated, children, testid }) {
    return (
        <div className="min-h-screen bg-background" data-testid={testid || "legal-page"}>
            <header className="border-b border-border bg-card">
                <div className="max-w-4xl mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
                    <Link to="/" className="flex items-center gap-2" data-testid="legal-logo">
                        <div className="font-display text-2xl font-bold tracking-tight">FormFlo<span className="text-primary">.</span></div>
                    </Link>
                    <Link to="/"><Button variant="ghost" size="sm" className="rounded-sm" data-testid="legal-back-btn"><ArrowLeft size={12} className="mr-1" /> Home</Button></Link>
                </div>
            </header>
            <article className="max-w-4xl mx-auto px-6 lg:px-10 py-14">
                <div className="label-overline mb-2">{overline}</div>
                <h1 className="text-4xl lg:text-5xl font-display font-bold tracking-tight mb-3">{title}</h1>
                <p className="text-xs font-mono text-muted-foreground mb-10">Last updated: {lastUpdated}</p>
                <div className="legal-prose space-y-6 text-sm leading-7 text-foreground">
                    {children}
                </div>
                <div className="border-t border-border mt-14 pt-8 text-xs text-muted-foreground flex flex-wrap items-center gap-x-6 gap-y-2">
                    <Link to="/privacy" className="hover:text-primary">Privacy Policy</Link>
                    <Link to="/terms" className="hover:text-primary">Terms &amp; Conditions</Link>
                    <Link to="/refund" className="hover:text-primary">Refund Policy</Link>
                    <span className="ml-auto">© {new Date().getFullYear()} Rishmathi Tech Ventures Pvt Ltd</span>
                </div>
            </article>
        </div>
    );
}
